import React from 'react';
import { twMerge } from 'tailwind-merge';

type HelperTextProps = {
	children?: string | React.ReactNode;
	className?: string;
	error?: string | React.ReactNode;
};

const HelperText = ({ children, className, error }: HelperTextProps) => {
	const variantStyles = {
		default: 'text-tertiary',
		error: 'text-error',
	};

	if (!error && !children) return null;

	return (
		<p
			role={error ? 'alert' : undefined}
			aria-live={error ? 'polite' : undefined}
			className={twMerge(
				'text-sm block mt-1',
				error ? variantStyles.error : variantStyles.default,
				className,
			)}
		>
			{error || children}
		</p>
	);
};

export default HelperText;
